import { render } from "./TaskSettingsButtons.vue?vue&type=template&id=385dbac7"
import script from "./TaskSettingsButtons.vue?vue&type=script&lang=js"
export * from "./TaskSettingsButtons.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsButtons.vue?vue&type=style&index=0&id=385dbac7&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__